import * as React from 'react';
import { connect } from 'react-redux';

import IDetails, { TDetails } from './IDetails';
import { setFormDirty } from '@company/features/action.company';
import { TReducers } from '@features/reducers';
import Editable from '../Editable/Editable';
import Social from '../SocialComponent/SocialComponent';
import IV from '../InputValidation/InputValidation';
import countries from '@features/staticData/countries';
import SaveHOC from '../HOC/SaveHOC';
import CompanyHeader from '../CompanyHeader/CompanyHeader';
import StageComponent from '../StageComponent/StageComponent';
import Markets from '../Industry/Industry';
import PinSVG from '../../icons/pin.svg';
import LinkSVG from '../../icons/link.svg';
import StarSVG from '../../icons/star.svg';

const isEqual = require('lodash.isequal');

import * as styles from './DetailsStyles.module.scss';

class Details extends React.Component<IDetails, TDetails> {

  constructor(props: IDetails) {
    super(props);

    const website = this.props.companyDetails.website ?
      this.props.companyDetails.website :
      this.props.companyDetails.social_media.website;

    this.state = {
      data: {
        ...this.props.companyDetails,
        website: website,
        social_media: this.arraySocialMedia(this.props.companyDetails.social_media),
      },
      shortDescription: true,
      error: false,
    };
  }

  getImageId = (imgResp: {
    id: number;
    url: string;
    to_delete_id: number;
  }) => {
    this.setState({
      data: {
        ...this.state.data,
        avatar: {
          id: imgResp.id,
          url: imgResp.url,
          to_delete_id: imgResp.to_delete_id ? imgResp.to_delete_id : undefined,
        },
      },
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: IDetails) {
    if (!isEqual(nextProps.companyDetails, this.props.companyDetails)) {
      const website = nextProps.companyDetails.website ?
        nextProps.companyDetails.website :
        nextProps.companyDetails.social_media.website;
      this.setState({
        data: {
          ...nextProps.companyDetails,
          website,
          social_media: this.arraySocialMedia(nextProps.companyDetails.social_media),
        },
      });
    }
  }

  componentDidUpdate(prevProps: IDetails, prevState: TDetails) {
    if (!isEqual(prevState.data, this.state.data) && this.props.editMode && !this.props.formDirty) {
      this.props.dispatch(setFormDirty(true));
    }
  }

  shortDescription = (desc: string) => {
    if (desc.length <= 250 || !this.state.shortDescription) return <p>{desc}</p>;

    return (
      <p>
        {desc.substr(0, 250) + '...'}
        <span onClick={() => {this.setState({ shortDescription: false });}}>Show more</span>
      </p>
    );
  }

  selectChange = (e: React.BaseSyntheticEvent) => {
    const selectedCountry = countries.find((elem: {slug: string; name: string}) => (elem.slug === e.target.value));

    this.setState({
      data: {
        ...this.state.data,
        location: {
          ...this.state.data.location,
          country: e.target.value,
          country_name: selectedCountry ? selectedCountry.name : this.state.data.location.country_name,
        },
      },
    });
  }

  updateCompanyName = (newName: string) => {
    this.setState({
      data: {
        ...this.state.data,
        name: newName,
      },
    });
  }

  arraySocialMedia(socials: any) {
    if (!Array.isArray(socials)) {
      const array:any = [];
      Object.keys(socials).forEach((key) => {
        if (key !== 'website') array.push({ [key]: socials[key] });
      });

      return array;
    }

    return socials;
  }

  getSocials = (data: {}[]) => {
    this.setState({
      data: {
        ...this.state.data,
        social_media: data,
      },
    });
  }

  updateStateFromChild = (name: string, data: object) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: data,
      },
    });
  }

  render() {
    const { dispatch } = this.props;
    const { data } = this.state;

    return (
      <React.Fragment>
        <CompanyHeader
          companyID={this.props.companyDetails.id}
          editMode={this.props.editMode}
          name={data.name}
          legal_name={data.legal_name || ''}
          dispatch={this.props.dispatch}
          getImageId={this.getImageId}
          logo={data.avatar}
          markets={data.markets}
          label={data.labels[0]}
          updateStateFromChild={this.updateStateFromChild}
          totalFollowers={this.props.companyDetails.total_followers}
          userSignedIn={this.props.userSignedIn}
          isOwner={this.props.isOwner}
          isCreator={this.props.isCreator}
        />
        {this.props.editMode ? (
          <div className={styles.detailsEdit}>
            <h2>Company Details</h2>
            <div className={styles.col6}>
              <div className={styles.holder}>
                <label>Year founded</label>
                <IV cl="details" type="year" dispatch={dispatch}>
                  <Editable type="input" name="founded" _this={this}/>
                </IV>
              </div>
              <div className={styles.holder}>
                <label>City</label>
                <IV cl="details" type="city" dispatch={dispatch}>
                  <Editable type="input" name="location.city" _this={this} cl={styles.text} />
                </IV>
              </div>
              <div className={[styles.holder, styles.detailsSelect].join(' ')}>
                <label>Country</label>
                <select name="country" onChange={this.selectChange} value={data.location.country}>
                  {countries.map((elem, index) => {
                    return (
                      <option
                        key={index}
                        value={elem.slug}
                      >
                          {elem.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className={styles.holder}>
                <label>Company description<span>(min. 20 characters)</span></label>
                <IV cl="details" type="companyDescription" dispatch={dispatch}>
                  <Editable type="textarea" name="description" _this={this} />
                </IV>
              </div>
            </div>
            <div className={styles.col6}>
              <div className={styles.holder}>
                <label>Website address</label>
                <IV cl="details" type="URL" dispatch={dispatch}>
                  <Editable type="input" name="website" _this={this} />
                </IV>
              </div>
              <div className={styles.holder}>
                <label>Social Media</label>
                <Social
                  editMode={true}
                  socials={data.social_media}
                  dispatch={this.props.dispatch}
                  validation={true}
                  getSocials={this.getSocials}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.details}>
            <h1>{data.name}</h1>
            {data.legal_name && <h2 className={styles.legalName}>{data.legal_name}</h2>}
            {data.description && !this.props.truncated && this.shortDescription(data.description)}
            {!this.props.truncated && <StageComponent stage={data.labels}/>}
            {!this.props.truncated && <Markets industries={data.markets} markets={true} editMode={false} />}
            <div className={styles.info}>
              {data.founded && <span className={styles.info_year}><StarSVG />{data.founded}</span>}
              <span className={styles.info_location}>
                <PinSVG />
                {data.location.city === null && data.location.country_name === null ?
                  '' :
                data.location.city ? `${data.location.city}, ` : null}
                {data.location.country_name}
              </span>
              {data.website && (
                <span className={styles.website}>
                  <LinkSVG />
                  <a className={styles.info_website} href={data.website} target="_blank" rel="noopener noreferrer">
                    {data.website}
                  </a>
                </span>
                )
              }
            </div>
            {!this.props.truncated && <Social editMode={false} socials={data.social_media}/>}
            {data.profile_id || this.props.isCreator || this.props.isOrganizational  ?
              null :
              <div className={styles.questions}>
                <a href={`/support/ownership_claim/${this.props.companyDetails.slug}`}>Is it your company?</a>
              </div>
            }
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    companyDetails: store.companyReducer.companyDetails,
    formDirty: store.companyReducer.formDirty,
    userSignedIn: !!store.userInfo,
    isOrganizational: store.companyReducer.userData.isOrganizational
      || (store.userInfo ? store.userInfo.organizational : undefined),
  };
};

export default connect(mapStateToProps)(SaveHOC(Details, 'companyDetails'));

